import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-grievances',
  templateUrl: './grievances.component.html',
  styleUrls: ['./grievances.component.scss']
})
export class GrievancesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
